import React from 'react'
import { ToastContainer } from 'react-toastify'
import { Helmet } from 'react-helmet'
import NotificationConfiguration from './NotificationConfiguration'

function GpsNotifications() {
    return (
        <>
            <section className=" bg-white">
                <Helmet><title>GPS Notifications</title></Helmet>
                <ToastContainer />
                <ul className="nav nav-tabs" id="myTab">
                     <li className="nav-item" role="downtimeTab">
                        <button className="nav-link active " id="notification-tab" type="button" data-bs-toggle="tab" data-bs-target="#notification" aria-controls="notification" role="tab" aria-selected="false">Notifications</button>
                    </li>
                </ul>
                <div className="tab-content" id="myTabContent">
                    <div className="tab-pane show active" id="notification" aria-labelledby="notification-tab">
                        <div className="tab_content_header">
                            <NotificationConfiguration  />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default GpsNotifications